import '../styles/main.scss';

document.addEventListener("DOMContentLoaded", () => {

    const API = "https://www.vli-logistica.com.br/wp-json/wp/v2";

    const yearsDiv = document.getElementById("vli-years");
    const contentDiv = document.getElementById("vli-content");
    const activeBar = document.querySelector(".active-bar");

    if (yearsDiv && contentDiv && activeBar)
    {
        /* ----------------------------
        1. BUSCAR ANOS
        ---------------------------- */
        fetch(`${API}/ano?per_page=100`)
            .then(r => r.json())
            .then(anos => {

                anos.sort((a, b) => b.name.localeCompare(a.name));

                anos.forEach((a, i) => {
                    yearsDiv.innerHTML += `
                        <span data-id="${a.id}" class="${i === 0 ? 'active' : ''}">
                            ${a.name}
                        </span>
                    `;
                });

                reposicionarBarra();

                carregarAno(anos[0].id);

                document.querySelectorAll(".vli-years span").forEach(btn => {
                    btn.addEventListener("click", () => {

                        document.querySelectorAll(".vli-years span")
                            .forEach(b => b.classList.remove("active"));

                        btn.classList.add("active");

                        reposicionarBarra();
                        carregarAno(btn.dataset.id);
                    });
                });
            });


        /* ----------------------------
        2. REPOSICIONAR LINHA AZUL
        ---------------------------- */
        function reposicionarBarra() {
            const ativo = document.querySelector(".vli-years span.active");
            if (!ativo) return;

            const rect = ativo.getBoundingClientRect();
            const parentRect = yearsDiv.getBoundingClientRect();

            activeBar.style.left = (rect.left - parentRect.left) + "px";
            activeBar.style.width = rect.width + "px";
        }

        window.addEventListener("resize", reposicionarBarra);


        /* ----------------------------
        3. CARREGAR POSTS DO ANO
        ---------------------------- */
        function carregarAno(termId) {

            contentDiv.innerHTML = `<div style="opacity:0;">.</div>`; // Fade suave

            fetch(`${API}/historia?ano=${termId}&per_page=100`)
                .then(r => r.json())
                .then(posts => {

                    if (!posts.length) {
                        contentDiv.innerHTML = "<p>Nenhum registro.</p>";
                        return;
                    }

                    let html = "";

                    posts.forEach(p => {
                        html += `
                            <div class="vli-item">
                                <h3>${p.title.rendered}</h3>
                                ${p.content.rendered}
                            </div>
                        `;
                    });

                    contentDiv.innerHTML = html;
                });
        }
    }
});
